import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FileUploadModule} from 'ng2-file-upload';
import {DropdownModule} from 'primeng/dropdown';
import {FormsModule} from '@angular/forms';
import {StepsModule} from 'primeng/steps';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ngfModule} from 'angular-file';

import {DocumentUploadComponent} from './document-upload/document-upload.component';
import {DocumentRoutingModule} from './document-routing.module';
import {CoreModule} from '../../core/core.module';
import {TranslateModule} from '@ngx-translate/core';
import {DocumentIssueComponent} from './document-issue/document-issue.component';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {CalendarModule} from 'primeng/calendar';
import {CheckboxModule} from 'primeng/checkbox';
import {PdfViewerModule} from 'ng2-pdf-viewer';
import {NgSelectModule} from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    DocumentRoutingModule,
    FileUploadModule,
    DropdownModule,
    FormsModule,
    StepsModule,
    NgbModule,
    ngfModule,
    CoreModule,
    TranslateModule,
    AutoCompleteModule,
    CalendarModule,
    CheckboxModule,
    NgSelectModule,
    PdfViewerModule
  ],
  declarations: [
    DocumentUploadComponent,
    DocumentIssueComponent
  ]

})
export class DocumentModule {
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document.module.ts